import { createApp } from 'vue'
import App from "./App.vue";
import router from "./router";
import store from './store';
//import { createPinia } from 'pinia'

import axios from "axios";
import VueAxios from "vue-axios";
import VueSweetalert2 from "vue-sweetalert2";
import { PerfectScrollbarPlugin } from 'vue3-perfect-scrollbar';
import Datepicker from '@vuepic/vue-datepicker';

import "sweetalert2/dist/sweetalert2.min.css";
import "vue3-perfect-scrollbar/style.css";
import '@vuepic/vue-datepicker/dist/main.css';
import "qalendar/dist/style.css";
//import '@/modules/agora/assets/themes.css'

// Agora
import AgoraMeeting from 'agora-meeting'
import 'agora-meeting/style.css'

import deviceDirective from '@/directives/device';

import { Enums } from "@/helpers/enums";
import { Links } from "@/helpers/links";
import { Constants } from "@/helpers/constants";
import { logError } from "@/helpers/logger";

import { appData, C, Text, D, J, Rnd } from "@/helpers/global";
import { SupportType, MethodType, Web, Msg, Popup, Wait, Ajax, Exporter, Animation } from "@/helpers/web";

import PartialView from "@/components/PartialView.vue";
import SmartModal from "@/components/SmartModal.vue";
import TabMenu from "@/components/TabMenu.vue";
import InputTel from "@/components/InputTel.vue";

const app = createApp(App);
//const pinia = createPinia();

// Helper to build entry
function buildEntry({ message, stack, source = "unknown", vm = null, route = null, extra = null }) {
    return {
        id: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
        timestamp: new Date().toISOString(),
        message: message || null,
        stack: stack || null,
        view: route ? { name: route.name || null, path: route.path || null } : { name: null, path: null },
        component: vm ? { name: vm.$options?.name || null, info: vm.$options?.__file || null } : { name: null, info: null },
        source,
        extra: extra || null
    };
}

// window.onerror (runtime errors)
window.addEventListener("error", (event) => {
    try {
        const route = router.currentRoute.value || null;
        const entry = buildEntry({
            message: event.message || String(event.error) || "window error",
            stack: event.error?.stack || null,
            source: "window-error",
            route,
            extra: {
                filename: event.filename,
                lineno: event.lineno,
                colno: event.colno
            }
        });
        logError(entry);
        // do not call event.preventDefault() unless you want to suppress browser console
    } catch (e) {
        console.error("Failed to log window error", e);
    }
});

// unhandledrejection (Promise rejections)
window.addEventListener("unhandledrejection", (ev) => {
    try {
        const route = router.currentRoute.value || null;
        const reason = ev.reason;
        const entry = buildEntry({
            message: reason?.message || String(reason),
            stack: reason?.stack || null,
            source: "promise-rejection",
            route,
            extra: { reason }
        });
        logError(entry);
    } catch (e) {
        console.error("Failed to log unhandledrejection", e);
    }
});

const globalProperties = {
    Enums, Links, Constants,
    appData, C, Text, D, J, Rnd,
    SupportType, MethodType, Web, Msg, Popup, Wait, Ajax, Exporter, Animation,
    $error(page, ex) { router.push({ name: "error", params: { page: page, msg: ex.message } }); },
    $go(link) { if (link) { router.push(link); } },
};

app
    .config.globalProperties = {
        ...app.config.globalProperties,
        ...globalProperties
};

// Vue global error handler (component errors)
app.config.errorHandler = (err, vm, info) => {
    try {
        const route = router.currentRoute.value || null;
        const entry = buildEntry({
            message: err?.message || String(err),
            stack: err?.stack || null,
            source: "vue-error",
            vm,
            route,
            extra: { info }
        });
        logError(entry);
        // optionally also console.error
        console.error("[Vue Error]", err, info);
    } catch (e) {
        console.error("Error in app.config.errorHandler", e);
    }
};

app
    .use(router)
    .use(store)
    //.use(pinia)
    .use(AgoraMeeting)
    .use(VueAxios, axios)
    .use(VueSweetalert2)
    .use(PerfectScrollbarPlugin);

app.directive("device", deviceDirective);

app.component("PartialView", PartialView)
    .component('Datepicker', Datepicker)
    .component("TabMenu", TabMenu)
    .component("input-tel", InputTel)
    .component("modal", SmartModal);

app.mount("#app");

import "bootstrap";